import { createApp } from 'vue'
import App from './App.vue'

import 'element-plus/theme-chalk/index.css'
import ElementPlus from 'element-plus'
import "@element-plus/icons-vue"
import router from "@/router";
import './styles/style.less'
import { SwipeCell, Cell, Button, ActionSheet, Picker, Popup, TimePicker, closeDialog, Uploader, showConfirmDialog, showLoadingToast, DatePicker } from 'vant';
import 'vant/lib/index.css'
import store from "@/store";

const app = createApp(App)
//自定义指令-列表新增元素后自动滚动底部
app.directive("scrollBottom", {
    updated(el) {
        // 这里的el即是绑定指令处的dom元素
        el.scrollTo(0, 0)
    }
})
showLoadingToast({
    message: '加载中...',
    duration: 500,
    forbidClick: true,
});

app.directive('infinite-scroll', {
    inserted: function (el, binding) {
        let isLoading = false; // 标记是否正在加载数据

        window.addEventListener('scroll', function () {

            // console.log(el.getBoundingClientRect().bottom, document.documentElement.clientHeight + 50, "dddddddddddddd");
            if (!isLoading && checkIfReachBottom()) {
                isLoading = true;
                // 处理上拉加载逻辑
                console.log("开始上拉加载");
                // ...其他操作

                // 模拟数据加载完成后更新列表
                setTimeout(() => {
                    // 添加新数据到列表
                    // ...
                    console.log('添加完数据');
                    // 结束下拉状态
                    isLoading = false;
                }, 2000);
            }
        });

        function checkIfReachBottom() {
            return el.getBoundingClientRect().bottom <= document.documentElement.clientHeight + 50;
        }
    }
});

app.config.errorHandler = (err) => {
    console.log(err);
};
// 屏蔽警告信息
app.config.warnHandler = (message) => {
    console.log(message);
};

app.use(ElementPlus).use(router).use(SwipeCell).use(Cell).use(Button).use(ActionSheet).use(Picker).use(Popup).use(TimePicker).use(Uploader).use(store).use(DatePicker).mount('#app')
